import { render, staticRenderFns } from "./LangSwitcher.vue?vue&type=template&id=5ddefa1e&scoped=true"
import script from "./LangSwitcher.vue?vue&type=script&lang=ts"
export * from "./LangSwitcher.vue?vue&type=script&lang=ts"
import style0 from "./LangSwitcher.vue?vue&type=style&index=0&id=5ddefa1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddefa1e",
  null
  
)

export default component.exports